import React from 'react';
import images from '../../themes/appImage';
import appconstants from "../../themes/appconstant";
import { useNavigate } from 'react-router-dom';
import ButtonLayout from "../../common/layoutButton";

const PasswordCreated = () => {
    const navigate = useNavigate();
    const handelClick = () => {
        navigate("/");
    };
    return (
        <div className="w-[100vw] h-[100vh] bg-background flex flex-col items-center justify-between">
            <div className='max-w-[424px] max-h-[455px]  flex items-center flex-col mt-5'>
                <img className=" mb-5 " src={images.logo} alt="metafit-logo" />
                <div className='w-full bg-white border border-royalPurple shadow-metafit-shadow mt-2 rounded-lg p-5 md:p-2 sm:w-[100vw] '>
                    <div className='flex items-center justify-center mt-[10px]'>
                        <div className='w-20 h-20 bg-royalPurple rounded-full flex justify-center items-center'>
                            <img src={images.lock} alt="password" />
                        </div>
                    </div>
                    <div className='text-2xl font-semibold text-dark text-center mt-8 mb-1'>{appconstants.newPasswordCreated}</div>
                    <div className="text-sm text-center text-gray60 mb-5">{appconstants.passwordText}</div>
                    <div className="mb-5">
                        <ButtonLayout text="Login" className="login-btn " onClick={handelClick} />
                    </div>
                </div>
            </div>
            <div className="text-sm text-light mb-3">{appconstants.metafitRights}</div>
        </div>
    );
}

export default PasswordCreated;
